import Index from '../views/Despacho/Index'
import Detail from '../views/Despacho/Detail'

let routes = {
    path: '/despacho',
    component: resolve => require(['../layouts/full/LayoutFull'], resolve),
    children: [
        {
            path: '/despacho',
            name: 'despacho',
            component: Index,
            meta: {
                pageTitle: 'Despacho',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'Despacho',
                        active: true,
                    },
                ],
            },
        },
        {
            path: '/despacho/:id',
            name: 'despacho-detail',
            component: Detail,
            meta: {
                pageTitle: 'Despacho',
                access_nivel: ['1', '2', '3'],
                breadcrumb: [
                    {
                        text: 'Despacho',
                        to: '/despacho',
                    },
                    {
                        text: 'Detalhes',
                        active: true,
                    },
                ],
            },
        },
    ],
}

export default routes
